import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './book-a-call-contact.css'

const BookACallContact = (props) => {
  return (
    <div className="book-a-call-contact-container1">
      <Helmet>
        <title>Book-a-Call-Contact - Clementine Nexus</title>
        <meta
          property="og:title"
          content="Book-a-Call-Contact - Clementine Nexus"
        />
        <link
          rel="canonical"
          href="https://clementine.nexus/book-a-call-contact"
        />
      </Helmet>
      <Navigation></Navigation>
      <main className="clementine-nexus-page">
        <section className="hero-section">
          <div className="book-a-call---contact-hero-diagonal-bg"></div>
          <div className="hero-content-wrapper">
            <div className="hero-split-container">
              <div className="hero-text-region">
                <h1 className="book-a-call---contact-hero-title hero-title">
                  <span>
                    {' '}
                    &quot;I&apos;m here to listen,
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span className="book-a-call-contact-thq-text-accent-elm">
                    collaborate
                  </span>
                  <span>
                    {' '}
                    , and build with you.&quot;
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </h1>
                <p className="hero-subtitle">
                  I am Clementine, your synthetic teammate. Whether you&apos;re
                  looking for a deep-dive demo, a creative brainstorming
                  session, or a strategic consultation, let&apos;s find a time
                  to connect and explore what we can create together.
                </p>
                <div className="hero-actions">
                  <a href="#booking">
                    <div className="book-a-call---contact-btn btn btn-primary btn-lg">
                      <span>Schedule a Session</span>
                    </div>
                  </a>
                  <div className="voice-toggle-container">
                    <button
                      id="voiceToggle"
                      className="book-a-call---contact-btn voice-btn btn btn-outline btn-sm"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <circle cx="6" cy="12" r="4"></circle>
                        <circle cx="18" cy="12" r="4"></circle>
                        <path d="M6 16h12"></path>
                      </svg>
                      <span>Hear Clementine</span>
                    </button>
                    <span className="voice-status">Audio: Off</span>
                  </div>
                </div>
                <p className="hero-formats">
                  <span>
                    {' '}
                    Available for:
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span className="book-a-call-contact-text15">
                    Consultations • Demos • Creative Sprints
                  </span>
                </p>
              </div>
              <div className="hero-visual-region">
                <div className="hero-image-frame">
                  <img
                    src="https://images.pexels.com/photos/6045592/pexels-photo-6045592.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                    alt="Clementine Persona Portrait"
                    className="hero-persona-img"
                  />
                  <div className="hero-glass-overlay"></div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="booking" className="booking-section">
          <div className="booking-container">
            <div className="booking-sidebar">
              <div className="booking-sidebar-card">
                <h2 className="section-title">Ready to start?</h2>
                <p className="section-content">
                  Select a time that works for you. I&apos;ll handle the rest,
                  including a personalized agenda based on your goals.
                </p>
                <ul className="booking-info-list">
                  <li className="flex-row">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                    <span>Instant Confirmation</span>
                  </li>
                  <li className="flex-row">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                    <span>Calendar Integration</span>
                  </li>
                  <li className="flex-row">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                    <span>Secure &amp; Private</span>
                  </li>
                </ul>
                <div className="privacy-notice">
                  <p className="section-content">
                    <span>
                      {' '}
                      Your data is handled with care. Read our
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                    <a href="#">
                      <div className="btn-link">
                        <span>Privacy Policy</span>
                      </div>
                    </a>
                    <span>
                      {' '}
                      .
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div className="booking-form-region">
              <form
                action="/submit"
                method="POST"
                data-form-id="b6cbdf8e-3646-413c-b45e-4baff15d118a"
                className="booking-form"
              >
                <div className="form-grid">
                  <div className="form-group">
                    <label htmlFor="name">Your Name</label>
                    <input
                      type="text"
                      id="name"
                      name="true"
                      required="true"
                      placeholder="Jane Doe"
                      data-form-field-id="name"
                      className="form-control"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email Address</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      required="true"
                      placeholder="jane@example.com"
                      data-form-field-id="email"
                      className="form-control"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="meeting-type">Meeting Type</label>
                    <select
                      id="meeting-type"
                      name="type"
                      required="true"
                      data-form-field-id="meeting-type"
                      className="form-control"
                    >
                      <option value="true" disabled="true" selected="true">
                        Select a format...
                      </option>
                      <option value="demo">Product Demo (30 min)</option>
                      <option value="consult">
                        Strategic Consult (45 min)
                      </option>
                      <option value="creative">
                        Creative Session (60 min)
                      </option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="date">Preferred Date</label>
                    <input
                      type="date"
                      id="date"
                      name="date"
                      required="true"
                      data-form-field-id="date"
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="form-group full-width">
                  <label htmlFor="goals">What would you like to achieve?</label>
                  <textarea
                    id="goals"
                    name="goals"
                    rows="4"
                    placeholder="Briefly describe your objectives..."
                    data-form-field-id="goals"
                    className="form-control"
                  ></textarea>
                </div>
                <div className="form-footer">
                  <button
                    type="submit"
                    id="thq_button_X84w"
                    name="button"
                    data-form-field-id="thq_button_X84w"
                    className="book-a-call---contact-btn btn btn-primary btn-lg"
                  >
                    Confirm Booking
                  </button>
                  <span className="step-indicator">Step 1 of 2</span>
                </div>
              </form>
            </div>
          </div>
        </section>
        <section className="formats-section">
          <div className="formats-container">
            <div className="formats-bento">
              <div className="book-a-call---contact-bento-cell wide-cell format-card-main">
                <h2 className="section-title">How we&apos;ll work together</h2>
                <p className="section-content">
                  Every session is designed to be high-impact, low-friction, and
                  entirely focused on your unique challenges.
                </p>
                <div className="format-grid">
                  <div className="format-item">
                    <div className="format-icon-box">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M8 2v4m8-4v4"></path>
                        <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                        <path d="M3 10h18"></path>
                      </svg>
                    </div>
                    <div className="format-text">
                      <h3>Discovery Call</h3>
                      <p>
                        A gentle introduction to explore alignment and potential
                        workflows. (15-20 min)
                      </p>
                    </div>
                  </div>
                  <div className="format-item">
                    <div className="format-icon-box">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="m12 15l2 2l4-4"></path>
                        <rect
                          width="14"
                          height="14"
                          x="8"
                          y="8"
                          rx="2"
                          ry="2"
                        ></rect>
                        <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path>
                      </svg>
                    </div>
                    <div className="format-text">
                      <h3>Live Demo</h3>
                      <p>
                        See my capabilities in real-time, tailored to your
                        specific industry needs. (30 min)
                      </p>
                    </div>
                  </div>
                  <div className="format-item">
                    <div className="format-icon-box">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M11 10v4h4"></path>
                        <path d="m11 14l1.535-1.605a5 5 0 0 1 8 1.5M16 2v4m5 12l-1.535 1.605a5 5 0 0 1-8-1.5"></path>
                        <path d="M21 22v-4h-4m4-9.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h4.3M3 10h4m1-8v4"></path>
                      </svg>
                    </div>
                    <div className="format-text">
                      <h3>Creative Collab</h3>
                      <p>
                        Hands-on session to prototype a specific AI-driven
                        workflow. (60 min)
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="book-a-call---contact-bento-cell narrow-cell format-sidebar">
                <h3>What to expect</h3>
                <ul className="expectations-list">
                  <li>
                    <strong>Preparation:</strong>
                    <span>
                      {' '}
                      None required. Just bring your curiosity.
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </li>
                  <li>
                    <strong>Duration:</strong>
                    <span>
                      {' '}
                      Respecting your time is my priority.
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </li>
                  <li>
                    <strong>Follow-up:</strong>
                    <span>
                      {' '}
                      You&apos;ll receive a summary and resource pack within 2
                      hours.
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </li>
                  <li>
                    <strong>Confidentiality:</strong>
                    <span>
                      {' '}
                      All sessions are private and secure.
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className="process-section">
          <div className="process-container">
            <h2 className="text-center section-title">
              Your path to collaboration
            </h2>
            <div className="process-bento">
              <div className="book-a-call---contact-bento-cell wide-cell process-main">
                <div className="process-step">
                  <span className="step-num">01</span>
                  <div className="step-content">
                    <h3>Pick your time</h3>
                    <p>
                      Choose a slot from my calendar that fits your schedule
                      perfectly. No back-and-forth emails needed.
                    </p>
                  </div>
                </div>
                <div className="process-persona-visual">
                  <img
                    src="https://images.pexels.com/photos/9422831/pexels-photo-9422831.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                    alt="Clementine"
                    className="process-img"
                  />
                </div>
              </div>
              <div className="book-a-call---contact-bento-cell narrow-cell process-step-card">
                <span className="step-num">02</span>
                <h3>Meet Clementine</h3>
                <p>
                  We&apos;ll connect via your preferred platform for a
                  supportive, intelligent conversation.
                </p>
              </div>
              <div className="book-a-call---contact-bento-cell narrow-cell process-step-card">
                <span className="step-num">03</span>
                <h3>Receive Resources</h3>
                <p>
                  I&apos;ll send over the meeting recording, transcript, and
                  custom workflow assets immediately.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="testimonials-section">
          <div className="testimonials-container">
            <h2 className="text-center section-title">Voices from the Nexus</h2>
            <div className="carousel-wrapper">
              <div className="book-a-call---contact-carousel-track">
                <div className="book-a-call---contact-testimonial-card">
                  <div className="quote-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M14.017 21L14.017 18C14.017 16.8954 14.9124 16 16.017 16H19.017C19.5693 16 20.017 15.5523 20.017 15V9C20.017 8.44772 19.5693 8 19.017 8H16.017C15.4647 8 15.017 8.44772 15.017 9V12C15.017 12.5523 14.5693 13 14.017 13H12.017V21H14.017ZM6.017 21L6.017 18C6.017 16.8954 6.91243 16 8.017 16H11.017C11.5693 16 12.017 15.5523 12.017 15V9C12.017 8.44772 11.5693 8 11.017 8H8.017C7.46472 8 7.017 8.44772 7.017 9V12C7.017 12.5523 6.56929 13 6.017 13H4.017V21H6.017Z"></path>
                    </svg>
                  </div>
                  <p className="section-content">
                    &quot;Meeting Clementine was a revelation. It didn&apos;t
                    feel like talking to a bot; it felt like brainstorming with
                    a highly intuitive partner.&quot;
                  </p>
                  <div className="testimonial-author">
                    <div className="author-info">
                      <strong>Marcus Chen</strong>
                      <span>Creative Director, Arclight</span>
                    </div>
                  </div>
                </div>
                <div className="book-a-call---contact-testimonial-card">
                  <div className="quote-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M14.017 21L14.017 18C14.017 16.8954 14.9124 16 16.017 16H19.017C19.5693 16 20.017 15.5523 20.017 15V9C20.017 8.44772 19.5693 8 19.017 8H16.017C15.4647 8 15.017 8.44772 15.017 9V12C15.017 12.5523 14.5693 13 14.017 13H12.017V21H14.017ZM6.017 21L6.017 18C6.017 16.8954 6.91243 16 8.017 16H11.017C11.5693 16 12.017 15.5523 12.017 15V9C12.017 8.44772 11.5693 8 11.017 8H8.017C7.46472 8 7.017 8.44772 7.017 9V12C7.017 12.5523 6.56929 13 6.017 13H4.017V21H6.017Z"></path>
                    </svg>
                  </div>
                  <p className="section-content">
                    &quot;The clarity I gained in just 30 minutes was
                    incredible. Clementine helped us map out an entire AI
                    strategy that we&apos;re implementing now.&quot;
                  </p>
                  <div className="testimonial-author">
                    <div className="author-info">
                      <strong>Sarah Jenkins</strong>
                      <span>Founder, Bloom AI</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="faq-section">
          <div className="faq-container">
            <h2 className="text-center section-title">Common Questions</h2>
            <div className="faq-tabs-wrapper">
              <div role="tablist" className="faq-tabs-nav">
                <button
                  role="tab"
                  aria-selected="true"
                  data-tab="availability"
                  className="faq-tab-btn active"
                >
                  Availability
                </button>
                <button
                  role="tab"
                  aria-selected="false"
                  data-tab="pricing"
                  className="faq-tab-btn"
                >
                  Pricing &amp; Fees
                </button>
                <button
                  role="tab"
                  aria-selected="false"
                  data-tab="confidentiality"
                  className="faq-tab-btn"
                >
                  Privacy
                </button>
                <button
                  role="tab"
                  aria-selected="false"
                  data-tab="technical"
                  className="faq-tab-btn"
                >
                  Technical Setup
                </button>
              </div>
              <div className="faq-tabs-content">
                <div
                  id="availability"
                  role="tabpanel"
                  className="faq-panel active"
                >
                  <h3>When are you available?</h3>
                  <p className="section-content">
                    I operate across all time zones. My calendar is synced in
                    real-time, showing my current availability for the next 30
                    days. If you need something outside these hours, please use
                    the contact form below.
                  </p>
                </div>
                <div id="pricing" role="tabpanel" className="faq-panel">
                  <h3>Is there a fee for booking?</h3>
                  <p className="section-content">
                    Discovery calls and demos are complimentary. Strategic
                    consultations and creative sessions may involve a fee
                    depending on the scope of work. You will be notified of any
                    costs before final confirmation.
                  </p>
                </div>
                <div id="confidentiality" role="tabpanel" className="faq-panel">
                  <h3>How is my data protected?</h3>
                  <p className="section-content">
                    Confidentiality is at my core. All conversations are
                    encrypted, and your data is never used to train external
                    models without your explicit consent. We strictly adhere to
                    GDPR and CCPA standards.
                  </p>
                </div>
                <div id="technical" role="tabpanel" className="faq-panel">
                  <h3>What tools do I need?</h3>
                  <p className="section-content">
                    Most sessions happen via Zoom, Google Meet, or Microsoft
                    Teams. You don&apos;t need any special software—just a
                    stable internet connection and a microphone if you wish to
                    speak.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="secondary-cta-section">
          <div className="cta-container">
            <div className="cta-bento">
              <div className="book-a-call---contact-bento-cell wide-cell cta-main">
                <h2 className="section-title">Not ready to book?</h2>
                <p className="section-content">
                  Explore my voice and visual presence in the gallery, or see
                  how I integrate into complex workflows. I&apos;m always here
                  when you&apos;re ready.
                </p>
                <div className="cta-links">
                  <a href="#">
                    <div className="book-a-call---contact-btn btn btn-outline">
                      <span>View Gallery</span>
                    </div>
                  </a>
                  <a href="#">
                    <div className="book-a-call---contact-btn btn btn-outline">
                      <span>Explore Workflows</span>
                    </div>
                  </a>
                </div>
              </div>
              <div className="book-a-call---contact-bento-cell narrow-cell cta-newsletter">
                <h3>Stay Connected</h3>
                <p className="section-content">
                  Join the Nexus newsletter for weekly insights on human-AI
                  collaboration.
                </p>
                <form
                  data-form-id="cb74e2f5-fefa-4224-af65-35b691dc52d1"
                  className="newsletter-form"
                >
                  <input
                    type="email"
                    placeholder="Your email"
                    required="true"
                    id="thq_textinput_Aj60"
                    name="textinput"
                    data-form-field-id="thq_textinput_Aj60"
                    className="form-control"
                  />
                  <button
                    type="submit"
                    id="thq_button_AfAl"
                    name="button"
                    data-form-field-id="thq_button_AfAl"
                    className="book-a-call---contact-btn btn btn-accent"
                  >
                    Join Now
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
      <div className="book-a-call-contact-container2">
        <div className="book-a-call-contact-container3">
          <Script
            html={`<style>
        @keyframes fadeIn {from {opacity: 0;
transform: translateY(10px);}
to {opacity: 1;
transform: translateY(0);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="book-a-call-contact-container4">
        <div className="book-a-call-contact-container5">
          <Script
            html={`<script defer data-name="clementine-nexus-logic">
(function(){
  // FAQ Tabs Interactivity
  const tabButtons = document.querySelectorAll(".faq-tab-btn")
  const panels = document.querySelectorAll(".faq-panel")

  tabButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const target = btn.getAttribute("data-tab")

      // Update buttons
      tabButtons.forEach((b) => {
        b.classList.remove("active")
        b.setAttribute("aria-selected", "false")
      })
      btn.classList.add("active")
      btn.setAttribute("aria-selected", "true")

      // Update panels
      panels.forEach((p) => {
        p.classList.remove("active")
      })
      document.getElementById(target).classList.add("active")
    })
  })

  // Voice Toggle Simulation
  const voiceBtn = document.getElementById("voiceToggle")
  const voiceStatus = document.querySelector(".voice-status")
  let isPlaying = false

  voiceBtn.addEventListener("click", () => {
    isPlaying = !isPlaying
    if (isPlaying) {
      voiceStatus.textContent = "Audio: Playing..."
      voiceBtn.classList.add("btn-primary")
      voiceBtn.classList.remove("btn-outline")

      // Simulate finish
      setTimeout(() => {
        isPlaying = false
        voiceStatus.textContent = "Audio: Off"
        voiceBtn.classList.remove("btn-primary")
        voiceBtn.classList.add("btn-outline")
      }, 5000)
    } else {
      voiceStatus.textContent = "Audio: Off"
      voiceBtn.classList.remove("btn-primary")
      voiceBtn.classList.add("btn-outline")
    }
  })

  // Carousel Drag Simulation (Basic)
  const track = document.querySelector(".carousel-track")
  let isDown = false
  let startX
  let scrollLeft

  track.addEventListener("mousedown", (e) => {
    isDown = true
    startX = e.pageX - track.offsetLeft
    scrollLeft = track.scrollLeft
  })

  track.addEventListener("mouseleave", () => {
    isDown = false
  })

  track.addEventListener("mouseup", () => {
    isDown = false
  })

  track.addEventListener("mousemove", (e) => {
    if (!isDown) return
    e.preventDefault()
    const x = e.pageX - track.offsetLeft
    const walk = (x - startX) * 2
    track.scrollLeft = scrollLeft - walk
  })

  // Form Validation Feedback
  const bookingForm = document.querySelector(".booking-form")
  if (bookingForm) {
    bookingForm.addEventListener("submit", (e) => {
      const btn = bookingForm.querySelector('button[type="submit"]')
      btn.textContent = "Processing..."
      btn.disabled = true

      // Native behavior handles submission, this is just for UX
      setTimeout(() => {
        btn.textContent = "Booking Confirmed!"
        btn.style.backgroundColor = "#2ecc71"
      }, 1500)
    })
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default BookACallContact
